import { render, staticRenderFns } from "./StudentBaseInformation.vue?vue&type=template&id=6ba34a99&"
import script from "./StudentBaseInformation.vue?vue&type=script&lang=js&"
export * from "./StudentBaseInformation.vue?vue&type=script&lang=js&"
import style0 from "./StudentBaseInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports